/**
 * Maps Typography variants to their semantic HTML elements
 * Ensures proper document structure and accessibility
 *
 * Can be overridden using the 'as' prop for flexibility
 *
 * @example
 * variant="h1" → renders as <h1>
 * variant="body" → renders as <p>
 * variant="caption" → renders as <span>
 */
export const variantElementMap = {
  display: 'h1',
  h1: 'h1',
  h2: 'h2',
  h3: 'h3',
  h4: 'h4',
  h5: 'h5',
  h6: 'h6',
  'body-large': 'p',
  body: 'p',
  'body-small': 'p',
  caption: 'span',
  overline: 'span',
  label: 'label',
  code: 'code',
} as const;

/**
 * Type for valid variant keys
 */
export type TypographyVariant = keyof typeof variantElementMap;
